// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyList-space1-wxAIN {
	margin-bottom: 6px !important;
}

.EmptyList-space2-ML7IU {
	margin-bottom: 12px !important;
}

.EmptyList-space3-Iv1UL {
	margin-bottom: 18px !important;
}

.EmptyList-space4-SVLFq {
	margin-bottom: 24px !important;
}

.EmptyList-space5-x1BPS {
	margin-bottom: 30px !important;
}

.EmptyList-space6-R7qvL {
	margin-bottom: 36px !important;
}

.EmptyList-space7-M_GtK {
	margin-bottom: 42px !important;
}

.EmptyList-spaceTop8-B1Njt {
	margin-bottom: 48px !important;
}

.EmptyList-spaceTop1-TGiCe {
	margin-top: 6px !important;
}

.EmptyList-spaceTop2-DZ2Cd {
	margin-top: 12px !important;
}

.EmptyList-spaceTop3-_1fDl {
	margin-top: 18px !important;
}

.EmptyList-spaceTop4-uLBZm {
	margin-top: 24px !important;
}

.EmptyList-spaceTop5-gIkyJ {
	margin-top: 30px !important;
}

.EmptyList-spaceTop6-iwk4e {
	margin-top: 36px !important;
}

.EmptyList-spaceTop7-k4YAq {
	margin-top: 42px !important;
}

.EmptyList-spaceTop8-B1Njt {
	margin-top: 48px !important;
}

.EmptyList-noMargin-quuOO {
	margin: 0px !important;
}

.EmptyList-padding1-UOQpI {
	padding-bottom: 6px !important;
}

.EmptyList-padding2-Uk0EL {
	padding-bottom: 12px !important;
}

.EmptyList-padding3-ZkMJi {
	padding-bottom: 18px !important;
}

.EmptyList-padding4-FEocw {
	padding-bottom: 24px !important;
}

.EmptyList-padding5-omdFS {
	padding-bottom: 30px !important;
}

.EmptyList-padding6-RxQpj {
	padding-bottom: 36px !important;
}

.EmptyList-padding7-NCzJS {
	padding-bottom: 42px !important;
}

.EmptyList-paddingTop1-kFYUk {
	padding-top: 6px !important;
}

.EmptyList-paddingTop2-G7QZJ {
	padding-top: 12px !important;
}

.EmptyList-paddingTop3-J01_u {
	padding-top: 18px !important;
}

.EmptyList-paddingTop4-n2npd {
	padding-top: 24px !important;
}

.EmptyList-paddingTop5-DnJVd {
	padding-top: 30px !important;
}

.EmptyList-paddingTop6-uXglP {
	padding-top: 36px !important;
}

.EmptyList-paddingTop7-PFx4D {
	padding-top: 42px !important;
}

.EmptyList-noPadding-dYDbY {
	padding: 0px !important;
}

.EmptyList-textBold-k6A80 {
	font-weight: 500 !important;
}

.EmptyList-textBolder-yg7fN {
	font-weight: 700 !important;
}

.EmptyList-textNormal-tiXAo {
	font-weight: normal !important;
}

.EmptyList-spaceBottom20-a_RNW {
	margin-bottom: 20px;
}

.EmptyList-spaceBottom10-pEUUN {
	margin-bottom: 10px;
}

.EmptyList-marginNone-wKYOV {
	margin: 0;
}

.EmptyList-spaceBottom15-jcT2i {
	margin-bottom: 15px;
}

.EmptyList-marginTopNone-LGfjF {
	margin-top: 0;
}

.EmptyList-spaceTop11-Vref1 {
	margin-top: 11px;
}

.EmptyList-spaceTop21-gkNAU {
	margin-top: 21px;
}

.EmptyList-spaceTop20-eoCjE {
	margin-top: 20px;
}

.EmptyList-spaceTop10-kPIIh {
	margin-top: 10px;
}

/*New Design Text Colors */

.EmptyList-textDarkBlue-OPnfS {
	color: rgb(20, 39, 94) !important;
}

.EmptyList-textLightBlue-Q1a_i {
	color: rgb(57, 87, 106) !important;
}

.EmptyList-textLightSandleGreen-wSsIB {
	color: rgb(76, 86, 41) !important;
}

.EmptyList-textLightBrown-MIIkN {
	color: rgb(115, 79, 33) !important;
}

.EmptyList-textMediumMaroon-mv7HK {
	color: rgb(87, 37, 51) !important;
}

.EmptyList-textBrown-voVcR {
	color: rgb(160, 47, 24) !important;
}

.EmptyList-textMaroon-SoePw {
	color: rgb(155, 49, 67) !important;
}

.EmptyList-textDarkBrown-igipa {
	color: rgb(83, 18, 16) !important;
}

.EmptyList-textMediumBrown-cT_ny {
	color: rgb(142, 28, 10) !important;
}

.EmptyList-textSkyBlue-vM6qf {
	color: rgb(37, 117, 141) !important;
}

.EmptyList-textGray-Si868 {
	color: rgb(77, 65, 51) !important;
}

.EmptyList-panelHeader-PXFme {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	border-bottom: 1px solid var(--primary-border);
}

.EmptyList-textCenter-j9UVq {
	text-align: center;
}

.EmptyList-textTitle-J2w_J {
	font-size: 20px;
	font-weight: bold;
}

.EmptyList-textLead-qgvci {
	font-size: 18px;
	color: var(--secondary-foreground);
	margin-top: 10px;
}

.EmptyList-marginCenter-Vkt74 {
	margin: 50px auto 10px;
	display: block;
}

.EmptyList-marginTop-Xd1tA {
	margin-top: 10px;
}

.EmptyList-paddingBtn-C9COu {
	padding: 12px 21px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Payout/PayoutList/EmptyList.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,8CAA8C;AAC/C;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../helpers.css';\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textTitle {\n\tfont-size: 20px;\n\tfont-weight: bold;\n}\n\n.textLead {\n\tfont-size: 18px;\n\tcolor: var(--secondary-foreground);\n\tmargin-top: 10px;\n}\n\n.marginCenter {\n\tmargin: 50px auto 10px;\n\tdisplay: block;\n}\n\n.marginTop {\n\tmargin-top: 10px;\n}\n\n.paddingBtn {\n\tpadding: 12px 21px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EmptyList-space1-wxAIN`,
	"space2": `EmptyList-space2-ML7IU`,
	"space3": `EmptyList-space3-Iv1UL`,
	"space4": `EmptyList-space4-SVLFq`,
	"space5": `EmptyList-space5-x1BPS`,
	"space6": `EmptyList-space6-R7qvL`,
	"space7": `EmptyList-space7-M_GtK`,
	"spaceTop8": `EmptyList-spaceTop8-B1Njt`,
	"spaceTop1": `EmptyList-spaceTop1-TGiCe`,
	"spaceTop2": `EmptyList-spaceTop2-DZ2Cd`,
	"spaceTop3": `EmptyList-spaceTop3-_1fDl`,
	"spaceTop4": `EmptyList-spaceTop4-uLBZm`,
	"spaceTop5": `EmptyList-spaceTop5-gIkyJ`,
	"spaceTop6": `EmptyList-spaceTop6-iwk4e`,
	"spaceTop7": `EmptyList-spaceTop7-k4YAq`,
	"noMargin": `EmptyList-noMargin-quuOO`,
	"padding1": `EmptyList-padding1-UOQpI`,
	"padding2": `EmptyList-padding2-Uk0EL`,
	"padding3": `EmptyList-padding3-ZkMJi`,
	"padding4": `EmptyList-padding4-FEocw`,
	"padding5": `EmptyList-padding5-omdFS`,
	"padding6": `EmptyList-padding6-RxQpj`,
	"padding7": `EmptyList-padding7-NCzJS`,
	"paddingTop1": `EmptyList-paddingTop1-kFYUk`,
	"paddingTop2": `EmptyList-paddingTop2-G7QZJ`,
	"paddingTop3": `EmptyList-paddingTop3-J01_u`,
	"paddingTop4": `EmptyList-paddingTop4-n2npd`,
	"paddingTop5": `EmptyList-paddingTop5-DnJVd`,
	"paddingTop6": `EmptyList-paddingTop6-uXglP`,
	"paddingTop7": `EmptyList-paddingTop7-PFx4D`,
	"noPadding": `EmptyList-noPadding-dYDbY`,
	"textBold": `EmptyList-textBold-k6A80`,
	"textBolder": `EmptyList-textBolder-yg7fN`,
	"textNormal": `EmptyList-textNormal-tiXAo`,
	"spaceBottom20": `EmptyList-spaceBottom20-a_RNW`,
	"spaceBottom10": `EmptyList-spaceBottom10-pEUUN`,
	"marginNone": `EmptyList-marginNone-wKYOV`,
	"spaceBottom15": `EmptyList-spaceBottom15-jcT2i`,
	"marginTopNone": `EmptyList-marginTopNone-LGfjF`,
	"spaceTop11": `EmptyList-spaceTop11-Vref1`,
	"spaceTop21": `EmptyList-spaceTop21-gkNAU`,
	"spaceTop20": `EmptyList-spaceTop20-eoCjE`,
	"spaceTop10": `EmptyList-spaceTop10-kPIIh`,
	"textDarkBlue": `EmptyList-textDarkBlue-OPnfS`,
	"textLightBlue": `EmptyList-textLightBlue-Q1a_i`,
	"textLightSandleGreen": `EmptyList-textLightSandleGreen-wSsIB`,
	"textLightBrown": `EmptyList-textLightBrown-MIIkN`,
	"textMediumMaroon": `EmptyList-textMediumMaroon-mv7HK`,
	"textBrown": `EmptyList-textBrown-voVcR`,
	"textMaroon": `EmptyList-textMaroon-SoePw`,
	"textDarkBrown": `EmptyList-textDarkBrown-igipa`,
	"textMediumBrown": `EmptyList-textMediumBrown-cT_ny`,
	"textSkyBlue": `EmptyList-textSkyBlue-vM6qf`,
	"textGray": `EmptyList-textGray-Si868`,
	"panelHeader": `EmptyList-panelHeader-PXFme`,
	"textCenter": `EmptyList-textCenter-j9UVq`,
	"textTitle": `EmptyList-textTitle-J2w_J`,
	"textLead": `EmptyList-textLead-qgvci`,
	"marginCenter": `EmptyList-marginCenter-Vkt74`,
	"marginTop": `EmptyList-marginTop-Xd1tA`,
	"paddingBtn": `EmptyList-paddingBtn-C9COu`
};
module.exports = ___CSS_LOADER_EXPORT___;
